import './index.less'
import classNames from "classnames";
import { FileCenterContext, IFileCenterContext, Shadow, StrokeProps } from '@/common/components/FileCenterProvider';
import { useContext } from 'react';
import { RGBA } from '@/common/constants/interfaces';

interface FontSpecialEffectItemProps {
    selected: boolean;
    fontSizeProp: number;
    fontColorProp: RGBA;
    text?: string;
    strokeProp?: StrokeProps;
    shadowProp?: Shadow;
    className?: string;
    value?: any;
    onSelect: (value?: any) => void;
}

function FontSpecialEffectItem(props: FontSpecialEffectItemProps) {
    const { text, value, fontSizeProp, fontColorProp, strokeProp, shadowProp, className, selected, onSelect, ...restProps } = props;
    const { selectedWatermarkId, updateWatermark } = useContext<IFileCenterContext>(FileCenterContext);

    const textShadows = [];
    if (strokeProp) {
        const { strokeColor } = strokeProp;
        textShadows.push(`${strokeColor} -1px 0px,${strokeColor} 0px 1px, ${strokeColor} 1px 0px, ${strokeColor} 0px -1px`);
    }

    if (shadowProp) {
        const { shadowColor, blur } = shadowProp;
        textShadows.push(`1px 1px ${blur}px ${shadowColor}`);
    }

    const cs = classNames('font-special-effect-item', className)


    const handleClick = () => {
        onSelect(value);

        if (selectedWatermarkId) {
            updateWatermark(selectedWatermarkId, { fontColor: fontColorProp, stroke: strokeProp ? strokeProp : null, shadow: shadowProp ? shadowProp : null, background: null })
        }

    }

    const fontColor = fontColorProp ? fontColorProp.toRgbaString() : 'transparent';
    return (
        <div style={{ fontSize: fontSizeProp, textShadow: textShadows.join(','), color: fontColor }} className={cs} {...restProps} onClick={handleClick}>
            {text ? text : 'A'}
        </div>
    );
}

export default FontSpecialEffectItem;